import React from 'react';
import PropTypes from 'prop-types';

export const AccordionCollapsible = (props) => {
  const { id, children, isActive, extendClass = '' } = props;
  const openClass = isActive ? 'active' : '';
  const classes = `panel-collapsible ${openClass} ${extendClass}`;

  return (
    <div id={id} className={classes}>
      {children}
    </div>
  );
};

AccordionCollapsible.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  isActive: PropTypes.bool,
  extendClass: PropTypes.string,
};
